import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const Summarizer = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14912)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="37.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M94.9375 30.2857L38.2857 108.457C38.2857 108.457 38.6836 110.595 39.3919 111.366C40.1002 112.138 41.0608 112.571 42.0625 112.571H94.9375C95.9392 112.571 96.8998 112.138 97.6081 111.366C98.3164 110.595 98.7143 109.548 98.7143 108.457V34.4C98.7143 33.3088 98.3164 32.2623 97.6081 31.4908C96.8998 30.7192 94.9375 30.2857 94.9375 30.2857Z"
            fill="#E3E3E3"
          />
          <path
            d="M51.1429 48.2856H76.7589"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 55.9999H84.0777"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 63.7142H76.7589"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 71.4285H84.0777"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 79.1428H84.0777"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 86.8571H84.0777"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.1429 94.5714H76.7589"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="37.75"
            y="29.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <rect
            x="148.75"
            y="29.75"
            width="61.5"
            height="30.6429"
            rx="4.05"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M205.937 30.2859L149.286 58.3788C149.286 58.3788 149.684 59.147 150.392 59.4243C151.1 59.7016 152.061 59.8574 153.062 59.8574H205.937C206.939 59.8574 207.9 59.7016 208.608 59.4243C209.316 59.147 209.714 58.7709 209.714 58.3788V31.7645C209.714 31.3724 209.316 30.9963 208.608 30.719C207.9 30.4417 205.937 30.2859 205.937 30.2859Z"
            fill="#E3E3E3"
          />
          <path
            d="M161.971 41.6857H185.88"
            stroke="#191919"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M161.971 48.8857H192.711"
            stroke="#191919"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="148.9"
            y="29.9"
            width="61.2"
            height="30.3429"
            rx="3.9"
            stroke="#191919"
            strokeWidth="1.8"
          />
          <g clipPath="url(#clip1_1503_14912)">
            <path
              d="M131.352 47.4259L136.96 41.8241L131.352 36.2222"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M136.961 41.8241C126.374 41.8241 111.901 41.0861 110.039 55.3704"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M120.404 74.6141L117.998 77.0195L109.981 69.0016L112.386 66.5962C113.455 65.5613 114.888 64.9881 116.376 65.0002C117.864 65.0123 119.287 65.6087 120.339 66.6608C121.391 67.7129 121.988 69.1364 122 70.6242C122.012 72.1121 121.439 73.5451 120.404 74.6141Z"
            fill="#FF808C"
          />
          <path
            d="M101.225 93.7928L90 97L93.2072 85.7749L101.225 93.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M109.981 69.0048L93.2072 85.7783L101.225 93.7962L117.999 77.0227L109.981 69.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M120.404 74.6141L117.998 77.0195L109.981 69.0016L112.386 66.5962C113.455 65.5613 114.888 64.9881 116.376 65.0002C117.864 65.0123 119.287 65.6087 120.339 66.6608C121.391 67.7129 121.988 69.1364 122 70.6242C122.012 72.1121 121.439 73.5451 120.404 74.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.225 93.7928L90 97L93.2072 85.7749L101.225 93.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.981 69.0048L93.2072 85.7783L101.225 93.7962L117.999 77.0227L109.981 69.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14912">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14912">
            <rect
              width="22"
              height="31"
              fill="white"
              transform="translate(108 57) rotate(-90)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
